export class Intro {

    constructor(settings = {}) {
        this.settings = settings;

        this.introSection = $('.js-intro-bg');
        this.scaleSpeed = 0.3;
        this.opacitySpeed = 1;
        this.MQ = 800;

    }

    init() {
        this._setSettings();
        this.triggerAnimation();
    }

    _setSettings() {
        this.introSectionHeight = this.introSection.outerHeight();
    }

    //bind the scale event to window scroll if window width > $MQ (unbind it otherwise)
    triggerAnimation() {
        const self = this;

        if ($(window).width() >= this.MQ) {
            $(window).on('scroll', function () {
                //The window.requestAnimationFrame() method tells the browser that you wish to perform an animation- the browser can optimize it so animations will be smoother
                window.requestAnimationFrame(
                    function() {
                        self.animateIntro(self);
                    }
                );
            });
        } else {
            $(window).off('scroll');
        }
    }

    animateIntro(self) {

        let scrollPercentage = ($(window).scrollTop() / self.introSectionHeight).toFixed(5),
            scaleValue = 1 + scrollPercentage * self.scaleSpeed,
            yValue = scrollPercentage * self.scaleSpeed * 100 + '%';

        //check if the introSection is still visible
        if ($(window).scrollTop() < self.introSectionHeight) {
            self.introSection.css({
                '-moz-transform': 'scale(' + scaleValue + ') translateY(' + yValue + ')  translateZ(0)',
                '-webkit-transform': 'scale(' + scaleValue + ') translateY(' + yValue + ')  translateZ(0)',
                '-ms-transform': 'scale(' + scaleValue + ') translateY(' + yValue + ')  translateZ(0)',
                '-o-transform': 'scale(' + scaleValue + ') translateY(' + yValue + ')  translateZ(0)',
                'transform': 'scale(' + scaleValue + ') translateY(' + yValue + ')  translateZ(0)',
                'opacity': 1 - scrollPercentage * this.opacitySpeed
            });
        }
    }
}



// WEBPACK FOOTER //
// ./static/js/components/Intro.js